export default __webpack_public_path__ + "static/media/Bemyticket.6b56e4fb.png";